import type { ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

export interface BreadcrumbsData {
    breadcrumbs: BreadcrumbSegment[];
    setBreadcrumbs: (breadcrumbs: BreadcrumbSegment[]) => void;
}
export interface BreadcrumbSegment {
    name: string;
    path?: string;
    safeToLog?: boolean;
}
export const BreadcrumbsContext = createContext<BreadcrumbsData | null>(null);

export function useBreadcrumbs(): BreadcrumbsData {
    const context = useContext(BreadcrumbsContext);
    if (!context) {
        throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider');
    }
    return context;
}
export const BreadcrumbsProvider = ({ children }: { children: ReactNode }) => {
    const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbSegment[]>([]);
    const value = useMemo(() => ({ breadcrumbs, setBreadcrumbs }), [breadcrumbs, setBreadcrumbs]);
    return <BreadcrumbsContext.Provider value={value}>{children}</BreadcrumbsContext.Provider>;
};
